import React, { useState } from 'react'
import Sidebar from '../components/HomePage/SideBar';
import Navbar from '../components/HomePage/Navbar';
import PresentationSection from '../components/HomePage/PresentationSection';
import Formation from '../components/HomePage/FormationSection';
import Skills from '../components/HomePage/SkillsSection';
import Projects from '../components/HomePage/ProjectsSection';
import Contact from '../components/HomePage/ContactSection';
import Footer from '../components/CommonSections/Footer';
import ScrollToTop from '../components/ScrollToTop';


const Home = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />
            <PresentationSection />
            <Skills />
            <Formation />
            <Projects />
            <Contact />
            <Footer />
        </>
    )
}

export default Home
